/**
 * Route shell only. The screen is @alight/enrolment-ui, shared with apps/site
 * — one implementation, two databases (docs/HTBH-MIGRATION.md §8a).
 */
import { createFileRoute } from "@tanstack/react-router";
import { CheckinKioskPage } from "@alight/enrolment-ui";

export const Route = createFileRoute("/admin/checkin")({
  component: CheckinKioskPage,
});
